import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import axios from 'axios';
import config from '../config/config'

export const RequestContext = createContext();

export function RequestProvider(props) {

  const [requests, setRequests] = useState([])
  const [unviewedRequests, setUnviewedRequests] = useState([])

  // Load viewed requests from localStorage on component mount
  useEffect(() => {
    const viewedRequests = localStorage.getItem('viewedRequests');
    if (viewedRequests) {
      const viewedIds = JSON.parse(viewedRequests);
      updateUnviewedRequests(viewedIds);
    }
  }, []);

  // Update unviewed requests when requests change
  useEffect(() => {
    const viewedRequests = localStorage.getItem('viewedRequests');
    const viewedIds = viewedRequests ? JSON.parse(viewedRequests) : [];
    updateUnviewedRequests(viewedIds);
  }, [requests]);

  const updateUnviewedRequests = (viewedIds) => {
    const unviewed = requests.filter(request => !viewedIds.includes(request._id));
    setUnviewedRequests(unviewed);
  };

  const getRequests = useCallback(async (search) => {
    try {
      const response = await axios.put(`${config.apiUrl}/api/request/all`, {
        search: search
      });
      setRequests(response.data);

    } catch (err) {
      console.log(err);
    }
  }, []);

  const deleteRequest = async (id, search) => {
    try {
      const response = await axios.put(`${config.apiUrl}/api/request/delete/${id}`);
      getRequests(search)

    } catch (err) {
      console.log(err);
    }
  }

  const markRequestAsViewed = (requestId) => {
    const viewedRequests = localStorage.getItem('viewedRequests');
    const viewedIds = viewedRequests ? JSON.parse(viewedRequests) : [];
    
    if (!viewedIds.includes(requestId)) {
      const updatedViewedIds = [...viewedIds, requestId];
      localStorage.setItem('viewedRequests', JSON.stringify(updatedViewedIds));
      updateUnviewedRequests(updatedViewedIds);
    }
  };

  const markAllRequestsAsViewed = () => {
    const allRequestIds = requests.map(request => request._id);
    localStorage.setItem('viewedRequests', JSON.stringify(allRequestIds));
    setUnviewedRequests([]);
  };

  const clearViewedRequests = () => {
    localStorage.removeItem('viewedRequests');
    setUnviewedRequests(requests);
  };

  return (
    <RequestContext.Provider
      value={{
        getRequests,
        requests,
        deleteRequest,
        unviewedRequests,
        markRequestAsViewed,
        markAllRequestsAsViewed,
        clearViewedRequests
      }}
    >
      {props.children}
    </RequestContext.Provider>
  );
}
